<template>
  <div class="mj_page flex jb">
    <div class="left_area">
      <div class="left_top">
        <div class="scrollable-content">
          <div class="toolsIntroduce">

            <div class="right">
              <div>
                无损放大
              </div>
              <span>
                无损放大图片，支持2倍、3倍、4倍放大，有效改善放大后图像的噪点与锯齿问题
              </span>
            </div>
          </div>
          <div class="describe">
            <div class="refer_title">
              <div></div>
              上传图片（必填）
            </div>
            <div class="Reference_image" v-loading="upImgloading"
                 element-loading-background="rgba(122, 122, 122, 0.8)">
              <el-upload
                  class="upload-demo"
                  drag
                  :action="fileApi+'/api/front/upload/?fdir=mj_tool'"
                  :show-file-list="false"
                  :on-success="handleAvatarSuccess"
                  :before-upload="beforeAvatarUpload"
                  accept="image/jpeg, image/png, image/bmp"
                  multiple>
                <div v-if="form.iw_url" class="yesUpload">
                  <img :src="form.iw_url" alt="" class="yesUpload_img">
                  <div class="yesUpload_icon" @click.stop="form.iw_url=''">
                    <i class="el-icon-delete"></i>
                  </div>
                </div>
                <div v-else class="noUpload">
                  <i style="font-size: 25px;font-weight: 700;color: #c0c4cc;" class="el-icon-plus"></i>
                  <div style="margin: 5px 0"> 将图片拖到此处，或<span style=" color:#5865f2;">点击上传</span></div>
                  <div> 只能上传jpg/png文件，且不超过3MB</div>
                </div>
              </el-upload>
            </div>
          </div>
          <div class="describe">
            <div class="refer_title">
              <div></div>
              放大倍数（必填）
            </div>
            <div class="drawingMode">
              <div @click="form.upscale_factor=item.num" :class="form.upscale_factor===item.num?'mode':'itemMode'"
                   v-for="item in magnification">
                {{ item.title }}
                <!-- <div class="vip" v-if="item.num===1">
                  VIP限免
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 参数
      form: {
        // 上传图片
        // iw_url: 'https://picture.gptkong.com/20241207/15578cff6aa482419e85521e0d12c20c6f.png',
        iw_url: '',
        // 放大倍数
        tool_type: 'png',
        upscale_factor: 2,
        mode: 'base',
        output_format: 'png',
        output_quality: '95',
      },
      // 上传图片
      fileApi: FILE_API_SERVER,
      magnification: [
        {title: '2倍', num: 2},
        {title: '3倍', num: 3},
        {title: '4倍', num: 4},
      ],
      upImgloading:false,
    }
  },
  computed: {},
  created() {

  },
  methods: {
    // 上传图片
    handleAvatarSuccess(res) {
      this.upImgloading = false
      if(res.data.error !== ''){
        this.$message.error(res.data.error);
        return
      }
      this.form.iw_url = res.data.file_full_url;
    },
    beforeAvatarUpload(file) {
      const isLt3M = file.size / 1024 / 1024 < 3;
      const isValidType = ['image/jpeg', 'image/png', 'image/bmp'].includes(file.type);

      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
        img.onload = () => {
          const { width, height } = img;
          const isValidResolution = width >= 32 && width <= 1920 && height >= 32 && height <= 1080;

          if (!isValidType) {
            this.$message.error('只能上传 JPG/JPEG/PNG/BMP 格式的文件!');
            reject({ isValidType: false });
            return
          }

          if (!isLt3M) {
            this.$message.error('上传文件大小不能超过 3MB!');
            reject({ isLt3M: false });
            return
          }

          if (!isValidResolution) {
            this.$message.error('图片分辨率需大于 32x32 像素且小于 1920x1080 像素!');
            reject({ isValidResolution: false });
            return
          }
          this.upImgloading = true
          resolve({ isValidType, isLt3M, isValidResolution, });
        };
        img.onerror = () => {
          this.$message.error('无法读取图片分辨率，请检查图片是否损坏！');
          reject({ isImageValid: false });
        };
      });
    },

  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@keyframes scale-breathe {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
  }
  75% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}


.mj_page {
  width: 100%;
  height: 100%;
  background: #2b2d31;
  border-radius: 10px;
  display: flex;
  //align-items: center;
  //justify-content: center;
}

.left_area {
  width: 300px;
  height: 100%;
  display: flex;
  flex-direction: column;

  .createButton {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 15px 0;
    border-top: 1px solid #36373d;

    div {
      font-size: 16px;
      cursor: pointer;
      background-color: #5865f2;
      color: #fff;
      border-radius: 25px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 12px 30px;

      span {
        font-size: 12px;
      }
    }
  }

  .left_top {
    height: calc(100% - 76px);
    //overflow-y: auto;
    .goBack {
      margin: 5px 0 15px 0;
      font-size: 14px;
      color: #fff;
      display: flex;

      .iconFont {
        display: flex;
        margin-right: 20px;

        div {
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
          width: 16px;
          margin-right: 5px;

          img {
            width: 100%;
            //height: 100%;
            vertical-align: top;
            opacity: 1;
          }
        }
      }

      .font_title {
        font-weight: 700;
      }

    }
  }

  .left_nav {
    padding: 4px 0;
    height: 40px;
    border-radius: 6px;
    border: 1px solid #36373d;
    display: flex;
    align-items: center;

    color: #fff;

    div {
      flex: 1;
      text-align: center;
      margin: 0 4px;
      cursor: pointer;
    }

    .navSelected {
      background-color: #5865f2;
      border-radius: 4px;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }

  .scrollable-content {
    overflow-y: auto;
    height: calc(100% - 120px);
    margin: 10px 0;
    color: #fff;

    .toolsIntroduce {
      background-color: #1e1f22;
      padding: 16px 14px;
      display: flex;
      border-radius: 5px;

      .left {
        margin-right: 12px;
        width: 20px;

        img {
          width: 20px;
          height: 20px;
        }
      }

      .right {
        flex: 1;


        div {
          font-size: 14px;
          font-weight: 700;
          height: 20px;
          margin-bottom: 5px;
        }

        span {
          font-size: 12px;
          line-height: 20px;
        }

      }
    }

    .describe {
      .refer_title {
        height: 18px;
        margin: 15px 0;
        display: flex;
        align-items: center;
        font-size: 14px;

        div {
          height: 100%;
          border: 2px solid #5865f2;
          border-radius: 2px;
          margin-right: 5px;
        }
      }

      .Reference_image {
        width: 100%;
        height: 140px;
        overflow: hidden;

        .upload-demo {
          height: 100%;
        }

        /deep/ .el-upload-dragger {
          width: 280px;
          background-color: #1d2027;
          border-color: #3e4149;
          height: 140px;
        }

        /deep/ .el-upload-dragger:hover {
          border-color: #5865f2;
          height: 140px;
        }

        .noUpload {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          color: #606266;
        }

        .yesUpload {
          position: relative;

          .yesUpload_img {
            height: 140px;
          }

          .yesUpload_icon {
            position: absolute;
            right: 8px;
            bottom: 12px;
            //background-color: aquamarine;
            color: #c1bfbb;
            font-size: 25px;
          }

        }
      }

      .drawingMode {
        display: flex;
        justify-content: space-between;

        .itemMode {
          padding: 10px 25px;
          background-color: #1d2027;
          border-radius: 3px;
          border: 2px solid #5865f200;
          cursor: pointer;
          position: relative;

          .vip {
            position: absolute;
            color: #f0b132;
            font-size: 14px;
            font-weight: 700;
            top: -11px;
            right: 0;
          }
        }

        .mode {
          padding: 10px 25px;
          background-color: #1d2027;
          border-radius: 3px;
          border: 2px solid #5865f2;
          cursor: pointer;
          position: relative;

          .vip {
            position: absolute;
            color: #f0b132;
            font-size: 14px;
            font-weight: 700;
            top: -11px;
            right: 0;
          }
        }
      }

    }
  }
}


.fz13 {
  font-size: 13px;
}

.c-fff {
  color: #fff;
}


.con {
  width: 410px;
  height: 560px;
  padding: 20px;
  background-color: #1e1f22;
  border: 2px solid #5865f2;
  border-radius: 6px;

  .full {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;


    .avatar {
      flex-direction: column;
      cursor: pointer;

      .pic {
        width: 70px;
        height: 70px;
        border-radius: 50%;
        margin-bottom: 5px;
        margin-top: 5px;
      }

      .text {
        font-size: 14px;
        color: #fff;

        img {
          width: 14px;
          height: 14px;
          display: inline-block;
          margin-right: 5px;
        }
      }
    }

    .info_list {
      padding: 15px 18px;

      .info_list_title {
        font-size: 14px;
        color: #fff;
        margin-left: -16px;
      }

      .info_item {
        padding: 15px 0;
        border-bottom: 1px solid #36373d;

        .title {
          img {
            width: 16px;
            height: 16px;
            margin-right: 8px;
          }

          p {
            font-size: 14px;
            color: #b0b0b0;
          }
        }

        .text {
          font-size: 14px;
          color: #b0b0b0;

          .btn {
            padding: 0 14px;
            display: block;
            line-height: 34px;
            cursor: pointer;
            background-color: #5865f2;
            color: #fff;
            border-radius: 4px;

            &:hover {
              background-color: rgba(88, 101, 242, 0.867);
            }
          }
        }
      }
    }
  }
}


.create_error {
  width: 190px;
  height: 190px;
  background-color: #fff;
  border-radius: 4px;
  padding-top: 28px;
  text-align: center;
  font-size: 14px;
  margin-top: 20px;

  .error_icon {
    display: block;
    width: 35px;
    margin: 0 auto;
  }

  .error_text {
    color: #ccc;
    line-height: 64px;
  }

  .error_btn {
    display: inline-block;
    cursor: pointer;
    color: #ffab46;
    padding-top: 15px;
  }
}

.defeat_popup {
  width: 600px;
  padding: 0 30px 36px;
  background-color: #fff;
  border-radius: 10px;

  .popup_title {
    font-size: 16px;
    font-weight: bold;
    line-height: 76px;
    text-align: center;
  }

  .popup_content {
    padding-bottom: 10px;

    .content_item {
      padding-bottom: 18px;
      font-size: 13px;
      line-height: 25px;

      .item_answer {
        color: #999;
      }
    }
  }

  .close_btn {
    width: 240px;
    height: 50px;
    border: none;
    border-radius: 5px;
    background-color: #5865f2;
    color: #fff;
    font-size: 15px;
    display: block;
    margin: 0 auto;
  }
}


.Image_manipulation {
  //width: 500px;
  background-color: #3f3c3a;
  padding: 20px 20px;
  border-radius: 4px;
  position: relative;

  .clear {
    position: absolute;
    top: 0;
    right: 0;
    //background-color: #5865f2;
    border: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;

    .el-icon-error {
      font-size: 20px;
      color: #565658;
    }
  }

  .clear:hover {
    background-color: #343538;
  }
}


.creating_progress {
  margin-top: 15px;
  display: flex;
  align-items: center;
  width: 360px;

  .progress_bar {
    flex-grow: 1;
    height: 10px;
    border-radius: 5px;
    background-color: #dbefe4;
    margin-right: 6px;

    .progress_line {
      height: 100%;
      background-color: #f0b132;
      border-radius: 5px;
      transition: width 0.3s linear;
    }
  }

  .progress_percent {
    font-size: 12px;
    line-height: 1;
    color: #f0b132;
    white-space: nowrap;
  }
}

</style>